import { MileageLossCode } from '@/types/logs'
import { useGetCodes } from '../api/useGetCodes'
import { capitalizeFirstLetter } from '@/helpers/capitalizeFirstLetter'

export const useGetCodeName = () => {
    const { data: codes } = useGetCodes()

    return (code: string) => {
        if (code in MileageLossCode || !codes?.length) {
            return code
        }

        const codeData = codes.find((item) => item.code === code)

        return codeData?.description ?? capitalizeFirstLetter(code)
    }
}
